const blobs = new Map();

export const getBlob = (key) => {
	return blobs.get(key);
};

export const setBlob = (key, blob) => {
	blobs.set(key, blob);
};

export const popBlob = (key) => {
	blobs.delete(key);
};

export const clearAllBlobs = () => {
	blobs.clear();
};
